import request from '../../axios';

const putSaleAgents = async (payload: IPutSaleAgentsPayload) => {
  await request.put(`api/v2/store/edit-sale-agent`, payload);
};

export default putSaleAgents;
